import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import InfoIcon from '@material-ui/icons/Info';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import BusinessIcon from '@material-ui/icons/Business';
import UsuarioRegisterInfo from './components/UsuarioRegisterInfo';
import Box from '@material-ui/core/Box';
import UsuarioToolbar from './components/UsuarioRegisterToolbar';
import AppBar from '@material-ui/core/AppBar';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import UsuarioRegisterContacts from './components/UsuarioRegisterContacts/UsuarioRegisterContacts';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import UsuarioRegisterEmpresas from './components/UsuarioRegisterEmpresas';
import { isAuthenticated } from '../../helpers/authenticate';
import { ValidatorForm } from 'react-material-ui-form-validator';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginRight: theme.spacing(3),
    marginLeft: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
  },
  toolbar: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3)
  }
}));
function UsuarioRegister({history}) {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [usuario, setUsuario] = useState(history.location.state.usuario);
  const [edicao, setEdicao] = useState(history.location.state.edicao);

  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [tipoUsuarios, setTipoUsuarios] = useState({
    result: []
  });


  const [value, setValue] = React.useState(0);

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  useEffect(() => {
    async function carregarTipoUsuarios() {
      try{
        setLoading(true);
        const params = {
          limit: 100,
        };
        const dados = await api.get('tipo-pessoas/', {params: params});
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length !== 0){
            for(let i = 0, size = dados.data.result.length; i < size; i++){
              dados.data.result[i].on_mouse_over = false;
            }
            setTipoUsuarios(dados.data);
          }
          else{
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack('Não há tipos de usuários');
            setShowMessageSnack(true);
          }
        }
        else{
          console.log('oi');
        }

      }
      catch (e) {

      }
    }
    carregarTipoUsuarios();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        <Box
          p={3}
        >
          {children}
        </Box>
      </Typography>
    );
  }

  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
  }

  async function saveUsuario() {
    if(edicao){
      try{
        const baseUrl = ServiceValues.base_url_local;
        const api = ServiceAxios(baseUrl, timeout);
        usuario.cpfCnpj = usuario.cpfCnpj.replace('.', "");
        usuario.cpfCnpj = usuario.cpfCnpj.replace('.', "");
        usuario.cpfCnpj = usuario.cpfCnpj.replace('-', "");
        const usuario_put = {
          nome: usuario.nome,
          nomeFantasia: usuario.nomeFantasia,
          cpfCnpj: usuario.cpfCnpj,
          pessoa_fisica: true,
          email: usuario.email,
          sexo: usuario.sexo,
          dataNascimento: usuario.dataNascimento,
          idTipoUsuario: usuario.idTipoUsuario,
          senha: usuario.senha,
          login: usuario.login,
          enderecos: usuario.enderecos,
          telefones: usuario.telefones,
          empresas: usuario.empresas
        };
        const dados = await api.put(`usuarios/${usuario.idUsuario}`, usuario_put);
        if(dados.data.isSuccess){
          setMessageSnack('Empresa cadastrada com sucesso!');
          setTypeSnack('success');
          setShowMessageSnack(true);
          history.push('/usuario-list/');
        }
        else{
          setMessageSnack(dados.data.message);
          setTypeSnack('error');
          setShowMessageSnack(true);
          // history.push('/empresa-list/');
        }
      }
      catch (e) {
        setMessageSnack('Falha de comunicação. Contate o suporte!');
        setTypeSnack('error');
        setShowMessageSnack(true);
      }
    }
    else{
      try{
        let empresas = [];
        usuario.empresas.map((empresa, index) => {
          empresas.push({
            idEmpresa: empresa.idEmpresa
          });
        });

        const baseUrl = ServiceValues.base_url_local;
        const api = ServiceAxios(baseUrl, timeout);
        usuario.cpfCnpj = usuario.cpfCnpj.replace('.', "");
        usuario.cpfCnpj = usuario.cpfCnpj.replace('.', "");
        usuario.cpfCnpj = usuario.cpfCnpj.replace('-', "");
        const usuario_post = {
          nome: usuario.nome,
          nomeFantasia: usuario.nomeFantasia,
          cpfCnpj: usuario.cpfCnpj,
          pessoa_fisica: true,
          email: usuario.email,
          sexo: usuario.sexo,
          dataNascimento: usuario.dataNascimento,
          idTipoUsuario: usuario.idTipoUsuario,
          senha: usuario.senha,
          login: usuario.login,
          enderecos: usuario.enderecos,
          telefones: usuario.telefones,
          empresas: empresas
        };
        const dados = await api.post('usuarios/', usuario_post);
        if(dados.data.isSuccess){
          setMessageSnack('Usuário cadastrado com sucesso!');
          setTypeSnack('success');
          setShowMessageSnack(true);
          history.push('/usuario-list/');
        }
        else{
          setMessageSnack(dados.data.message);
          setTypeSnack('error');
          setShowMessageSnack(true);
          // history.push('/empresa-list/');
        }
      }
      catch (e) {
        setMessageSnack('Falha de comunicação. Contate o suporte!');
        setTypeSnack('error');
        setShowMessageSnack(true);
      }
    }
  }


  return (
    <ValidatorForm
      autoComplete="off"
      onSubmit={saveUsuario}
    >
      <div>
        <ProgressFullScreen
          open={loading}
          setOpen={setLoading}
        />
        <SnackbarCustom
          verticalOrientation='bottom'
          horizontalOrientation='center'
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
        <UsuarioToolbar
          className={classes.toolbar}
          saveUsuario={saveUsuario}
          history={history}
        />
        <Paper className={classes.root}>
          <AppBar position="static" color="inherit">

            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab label="Informações Gerais" icon={<InfoIcon />} {...a11yProps(0)} />
              <Tab label="Contatos" icon={<ContactPhoneIcon />} {...a11yProps(1)} />
              <Tab label="Empresas" icon={<BusinessIcon />} {...a11yProps(2)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <UsuarioRegisterInfo
              usuario={usuario}
              setUsuario={setUsuario}
              tipoUsuarios={tipoUsuarios}
              edicao={edicao}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <UsuarioRegisterContacts
              usuario={usuario}
              setUsuario={setUsuario}
              showMessageSnack={showMessageSnack}
              setShowMessageSnack={setShowMessageSnack}
              messageSnack={messageSnack}
              setMessageSnack={setMessageSnack}
              typeSnack={typeSnack}
              setTypeSnack={setTypeSnack}
              edicao={edicao}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <UsuarioRegisterEmpresas
              usuario={usuario}
              setUsuario={setUsuario}
              showMessageSnack={showMessageSnack}
              setShowMessageSnack={setShowMessageSnack}
              messageSnack={messageSnack}
              setMessageSnack={setMessageSnack}
              typeSnack={typeSnack}
              setTypeSnack={setTypeSnack}
              edicao={edicao}
            />
          </TabPanel>

        </Paper>
      </div>
    </ValidatorForm>

  );
};

export default UsuarioRegister;
